<template>
  <div class="form-check ps-0">
    <input
      :id="checkboxId"
      :value="value"
      type="checkbox"
      class="form-check-input"
      @change="toggle"
      :checked="value"
    >
    <label
      v-if="label"
      class="ps-3"
      :class="{ 'font-weight-bold': labelBold }"
      :for="checkboxId"
    >
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'LevCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    labelBold: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checkboxId () {
      return this.id || `checkbox-${Math.random().toString(36).substr(2, 9)}`;
    }
  },
  created () {

  },
  methods: {
    toggle(data) {
      this.$emit('input', data.target.checked);
      this.$emit('change', data.target.checked);
    }
  }
};
</script>
